export var groupTheme = {
  baseStyle: _ref => {
    var {
      spacing,
      width,
      height,
      allowOverflowX
    } = _ref;
    return {
      display: 'flex',
      gap: spacing,
      width,
      height,
      // Both `minWidth` and `maxWidth` are necessary to support text-ellipsis in descendant elements
      minWidth: 0,
      maxWidth: '100%',
      overflowX: allowOverflowX ? 'auto' : 'initial'
    };
  },
  variants: {
    horizontal: {
      flexDirection: 'row'
    },
    vertical: {
      flexDirection: 'column'
    }
  },
  defaultProps: {
    spacing: 's',
    width: 'auto',
    height: 'auto'
  }
};
//# sourceMappingURL=Group.theme.js.map